export const walletTypes = [
  { value: 1, text: 'payer', theme: 'neutral', dataQa: 'WALLET_ADD_INDIVIDUAL_WALLET_PAYER_RADIO' },
  {
    value: 2,
    text: 'beneficiary',
    theme: 'info',
    dataQa: 'WALLET_ADD_INDIVIDUAL_WALLET_BENEFICIARY_RADIO'
  }
];

export const transactionWalletTypes = [
  { value: true, text: 'technicalWallet' },
  { value: false, text: 'paymentWallet' }
];
